import { 
    GET_CONFIG_FORM85,
    GET_CUOTAS

} from '../types';

export default function ingresoRecobroReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM85:
            return { ...state, cfg_form85:action.payload }
        case GET_CUOTAS:
            return { ...state, datosDecPago:action.payload }
       
       
        default:
            return state
    }
}